export default __webpack_public_path__ + "static/media/thunder-breaker.697f5b3f.png";